import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import OvrsDashboardContainer from './containers/OvrsDashboardContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {
  const returnOVData = () => {
    const data = _.get(totalStats, 'item.total_ovr_payment_per_status');
    return {
      label: 'Ordinance Violations',
      total: _.get(totalStats, 'item.total_ovr_payment', 0),
      // photo: ''
      list: [
        { label: 'Waiting for Payment', value:  _.get(data, 'WAITING FOR PAYMENT', 0), borderClassName: 'waiting' },
        { label: 'For Checking', value:  _.get(data, 'FOR CHECKING', 0), borderClassName: 'checking' },
        { label: 'For Appearance', value:  _.get(data, 'FOR APPEARANCE', 0), borderClassName: 'appearance' },
        { label: 'For Pickup', value: _.get(data, 'FOR PICK-UP', 0), borderClassName: 'pickup' },
        { label: 'Pending', value:  _.get(data, 'PENDING', 0), borderClassName: 'waiting' },
        { label: 'Received', value:  _.get(data, 'RECEIVED', 0), borderClassName: 'received' },
        { label: 'For Resubmission', value: _.get(data, 'FOR RESUBMISSION', 0), borderClassName: 'rejected' },
        { label: 'Expired Reference Number', value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0), borderClassName: 'received' },
        { label: 'Paid', value:  _.get(data, 'PAID', 0), borderClassName: 'paid' },
        { label: 'Cancelled', value:  _.get(data, 'CANCELLED', 0), borderClassName: 'rejected' },
      ],
    }
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard data={returnOVData()} />
        </div>
        <div className="col-8 pr-0">
          <OvrsDashboardContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(TransactionsContainer);
